export default "__VITE_ASSET__64e211ff__"